import Link from "next/link";
import { CSSProperties, useEffect, useRef, useState } from "react";
import CloseBtn from "../../components/close_btn";
import BurgerMenu from "../BurgerMenu";
import ThemeSwitch from "../theme-switch";
import style from "./index.module.scss";

type headerProps = {
	isDark: boolean;
	setIsDark: () => void;
};

const socials = [
	{ title: "Telegram", id: "telegram", icon: "/image/socials/telegram.svg", link: "https://t.me/Alina_Avelis_author" },
	{ title: "Instagram", id: "instagram", icon: "/image/socials/instagram.svg", link: "https://www.instagram.com/alina_avelis/" },
	{ title: "Threads", id: "threads", icon: "/image/socials/threads.svg", link: "https://www.threads.com/@alina_avelis" },
	{ title: "Pinterest", id: "pinterest", icon: "/image/socials/pinterest.svg", link: "https://pin.it/2BxcI8LzP" },
	{ title: "VK", id: "vk", icon: "/image/socials/vk.svg", link: "https://vk.ru/club232285147" },
	{ title: "YouTube", id: "youtube", icon: "/image/socials/youtube.svg", link: "https://youtube.com/@alina-avelis?si=WMJxrOLaPHAUKQRn" },
	{ title: "Литнет", id: "litnet", icon: "/image/socials/litnet.svg", link: "https://litnet.com/ru/alina-avelis-u13493201/stories" },
	{ title: "Author.Today", id: "author-today", icon: "/image/socials/author-today.svg", link: "https://author.today/u/alinaavelis" },
];

const personalElementsLeft = [
	{
		text: "Основная страница",
		link: "/",
	},
	{
		text: "Все категории",
		link: "/categories",
	},
];

const personalElementsRight = [
	{
		text: "Премьера",
		link: "/premier",
	},
	{
		text: "Книги",
		link: "/books",
	},
	{
		text: "Все рассказы",
		link: "/stories",
	},
];

const AppHeader = ({ isDark, setIsDark }: headerProps) => {

	const mobileMenu = useRef<HTMLInputElement>(null);
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const media = window.matchMedia("(max-width: 576px)");
		const update = () => setIsMobile(media.matches);
		update();
		media.addEventListener("change", update);
		return () => media.removeEventListener("change", update);
	}, []);

	const handleOpenMenu = () => {
		mobileMenu.current?.classList.add("mobile_opened--open");
	};

	const onClose = () => {
		mobileMenu.current?.classList.remove("mobile_opened--open");
	};

	return (
		<header className={style.header}>
			<div className={style.switch_theme}>
				<ThemeSwitch checked={isDark} onChange={setIsDark} />
			</div>

			<div className={style.author_line}>
				<div>
					<div>
						<p className={style.author_name}>

							Алина Авелис
						</p>
						<a href="mailto:alinaavelis@gmail.com">
							alinaavelis@gmail.com
						</a>
					</div>
					{isMobile && (
						<p>
							{" "}
							Основной жанр -{" "}
							<span className="space-no-wrap">
								приключения/фэнтези
							</span>
						</p>
					)}
				</div>

				{isMobile && (
					<div>
						<BurgerMenu
							onClickHundler={() => {
								handleOpenMenu();
							}}
						/>
					</div>
				)}
			</div>

			<div className="mobile_opened" ref={mobileMenu}>
				<div className={style.author_line}>

					{!isMobile && (
						<p>
							{" "}
							Основной жанр -{" "}
							<span className="space-no-wrap">
								приключения/фэнтези
							</span>
						</p>
					)}
					{isMobile && (
						<div className="modal_top_close">
							<CloseBtn clickHandler={onClose} />
						</div>
					)}

					<div className={style.switch_theme_mobile}>
						<ThemeSwitch checked={isDark} onChange={setIsDark} />
					</div>

					<div className={style.subscribe_actions}>
						<div className={style.socials}>
							{socials.map(({ title, id, icon, link }) => (
								<a
									key={id}
									href={link || undefined}
									title={title}
									aria-label={title}
									aria-disabled={!link || undefined}
									className={style.social}
									target={link ? "_blank" : undefined}
									rel={link ? "noopener noreferrer" : undefined}
								>
									<span
										aria-hidden="true"
										className={style.social_icon}
										style={{ "--social-icon": `url("${icon}")` } as CSSProperties}
									/>
								</a>
							))}
						</div>

						<Link
							href="https://t.me/Alina_Avelis_author"
							target="_blank"
							className="btn btn_no_bg"
							rel="noreferrer"
						>
							Подписаться
						</Link>
					</div>
				</div>

				<div className={style.author_line}>
					<nav>
						<div className="flexbox-rows align-items-center justify-content-end">
							{personalElementsLeft.map((item, i) => {
								return (
									<Link
										key={"nav" + i}
										href={item.link}
										className={style.header__link}
										onClick={() => {
											onClose();
										}}
									>
										{item.text}
									</Link>
								);
							})}
						</div>

						<div className="flexbox-rows align-items-center justify-content-end">
							{personalElementsRight.map((item, i) => {
								return (
									<Link
										key={"nav" + i}
										href={item.link}
										className={style.header__link}
										onClick={() => {
											onClose();
										}}
									>
										{item.text}
									</Link>
								);
							})}
						</div>
					</nav>
				</div>
			</div>
		</header>
	);
};

export default AppHeader;
